export default __webpack_public_path__ + "static/media/correct-answer.f88b8b0a.svg";